<div class="route-panel">
    <div class="panel-head">
        <div class="panel-title">
            <span class="panel-title-icon tone-blue">
                <span class="material-icons-outlined">flight</span>
            </span>
            <div>
                <strong>Best Seller Routes</strong>
                <small>Reservations by route</small>
            </div>
        </div>
    </div>

    @if (loading()) {
        <div class="route-loading">
            <span class="material-icons-outlined spin">refresh</span>
        </div>
    } @else {
        <div class="route-bars">
            @for (route of topRoutes(); track route.route.depPort + route.route.arrPort) {
                <div class="route-row">
                    <div class="route-name">
                        {{ route.route.depPort }}
                        <span>→</span>
                        {{ route.route.arrPort }}
                    </div>
                    <div class="bar-track">
                        <div class="bar-fill" [style.width.%]="getBarWidth(route.reservation)"></div>
                    </div>
                    <div class="route-count">{{ route.reservation }}</div>
                </div>
            }
        </div>

        @if (topRoute(); as top) {
            <div class="route-summary">
                <div class="route-summary-icon">
                    <span class="material-icons-outlined">flight</span>
                </div>
                <div class="route-summary-copy">
                    <small>Top route</small>
                    <strong>{{ top.route.depPort }} → {{ top.route.arrPort }}</strong>
                </div>
                <div class="route-revenue">
                    <small>Revenue</small>
                    <strong>{{ top.revenue | number: '1.2-2' }}</strong>
                </div>
            </div>
        }
    }
</div>
